import { useLocation, useNavigate } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import React, { useRef, useState } from "react";
import { contact_us_reply } from "../../../api/apiHandler";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import * as Yup from "yup";
import { TOAST_ERROR, TOAST_SUCCESS } from "../../../utils/common.service";
import { useFormik } from "formik";
import { uploadImageOnAWS } from "../../aws/Service";

export default function ContactusReply({isLoader}) {

    const navigate = useNavigate()
    const location = useLocation()
    const PersonId = location.state && location.state.PersonId
    const personEmail = location.state && location.state.Email

    const handleBack = () => {
        navigate(-1);
    };

    const fileInputs = useRef([]);
    const resetFileInputs = () => {
        fileInputs.current.forEach((input) => {
            input.value = '';
        });
    };

    const contactUsSchema = Yup.object({
        subject: Yup.string().required("Please enter Subject"),
        body: Yup.string().required("Please enter body"),
        attachment: Yup.array()
    });

    const contactUsForm = useFormik({
        initialValues: {
            subject: '',
            body: '',
            attachment: ''
        },
        validationSchema: contactUsSchema,

        onSubmit: async (data ,  { resetForm }) => {
            
            isLoader(true)
            var image = []
            if (data.attachment) {
                for (let i = 0; i < data.attachment.length; i++) {
                    var attachment = await uploadImageOnAWS(data?.attachment[i], "contact_us_reply_attachments");
                    image.push({ attachment: attachment })
                }
                data.attachment = image
            }
            
            data.email = personEmail
            data.contact_us_id = PersonId
            
            contact_us_reply(data).then((response) => {
                if (response.code == 1) {
                    isLoader(false)
                    TOAST_SUCCESS(response.message);
                    navigate("/contactus-list")
                    contactUsForm.resetForm();
                    resetFileInputs();
                    setDocExtensions(Array(3).fill(null));
                    setPreviewUrls(Array(3).fill(null));
                } else {
                    TOAST_ERROR(response.message);
                    isLoader(false)
                }
            });
        },
    });

    const [docExtensions, setDocExtensions] = useState(Array(3).fill(null));
    const [previewUrls, setPreviewUrls] = useState(Array(3).fill(null));

    const handleImage = async (e, index) => {

        const file = e.target.files[0];

        // Allowed file types including Excel
        const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];

        // Validate file type
        if (!allowedFileTypes.includes(file?.type)) {
            TOAST_ERROR('Please attach a valid image (JPEG/PNG), PDF, DOC, or Excel file');
            return;
        }

        // Update file extension state
        const newDocExtensions = [...docExtensions];
        newDocExtensions[index] = file.type;
        setDocExtensions(newDocExtensions);

         // Create preview URL for images
        if (file.type.startsWith('image/')) {
            const previewUrl = URL.createObjectURL(file);
            const newPreviewUrls = [...previewUrls];
            newPreviewUrls[index] = previewUrl;
            setPreviewUrls(newPreviewUrls);
        }

        // const selectedImages = Array.from(e.target.files);
        const currentAttachment = contactUsForm.values.attachment || [];
        contactUsForm.setFieldValue('attachment', [...currentAttachment, file]);
    };

    const renderFilePreview = (index) => {
        const fileType = docExtensions[index];
    
        if (fileType?.startsWith('image/')) {
          return (
            <img
              src={previewUrls[index]}
              alt="Preview"
              className="image"
              style={{
                width: "100%",
                height: "166px",
                objectFit: "cover"
              }}
              onClick={() => fileInputs.current[index]?.click()}
            />
          );
        }
    
        if (fileType === 'application/pdf') {
          return (
            <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor"
              style={{ color: "red", margin: "30px" }} className="bi bi-filetype-pdf" viewBox="0 0 16 16"
              onClick={() => fileInputs.current[index]?.click()}>
              <path fillRule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z" />
            </svg>
          );
        }
    
        if (fileType?.includes('word')) {
          return (
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width={100} height={100}
              style={{ margin: "30px" }} viewBox="0 0 48 48"
              onClick={() => fileInputs.current[index]?.click()}>
              <path fill="#90CAF9" d="M40 45L8 45 8 3 30 3 40 13z"></path>
              <path fill="#E1F5FE" d="M38.5 14L29 14 29 4.5z"></path>
              <path fill="#1976D2" d="M16 21H33V23H16zM16 25H29V27H16zM16 29H33V31H16zM16 33H29V35H16z"></path>
            </svg>
          );
        }
    
        if (fileType?.includes('excel') || fileType?.includes('sheet')) {
          return (
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width={100} height={100}
              style={{ margin: "30px" }} viewBox="0 0 48 48"
              onClick={() => fileInputs.current[index]?.click()}>
              <defs>
                <linearGradient id="Excel_1" x1="36.2" y1="43.231" x2="11.8" y2="18.769" gradientUnits="userSpaceOnUse">
                  <stop offset="0" stopColor="#18884f" />
                  <stop offset="1" stopColor="#117e43" />
                </linearGradient>
              </defs>
              <path fill="url(#Excel_1)" d="M44,27H35v-4h9c0.552,0,1,0.447,1,1v2C45,26.553,44.552,27,44,27z" />
              <path fill="#185c37" d="M44,34H35v-4h9c0.552,0,1,0.447,1,1v2C45,33.553,44.552,34,44,34z" />
              <path fill="#21a366" d="M44,41H35v-4h9c0.552,0,1,0.447,1,1v2C45,40.553,44.552,41,44,41z" />
              <path fill="#107c41" d="M44,20H35v-4h9c0.552,0,1,0.447,1,1v2C45,19.553,44.552,20,44,20z" />
              <path fill="#185c37" d="M44,13H35V9h9c0.552,0,1,0.447,1,1v2C45,12.553,44.552,13,44,13z" />
              <path fill="#21a366" d="M41,6H35V2h6c0.552,0,1,0.447,1,1v2C42,5.553,41.552,6,41,6z" />
              <path fill="#107c41" d="M35,6v34h-6c-0.552,0-1-0.447-1-1V7c0-0.553,0.448-1,1-1H35z" />
              <path opacity="0.1" d="M35,6v34h-6c-0.552,0-1-0.447-1-1V7c0-0.553,0.448-1,1-1H35z" />
              <path fill="#33c481" d="M28,6v34h-6c-0.552,0-1-0.447-1-1V7c0-0.553,0.448-1,1-1H28z" />
              <path fill="#21a366" d="M21,6v34h-6c-0.552,0-1-0.447-1-1V7c0-0.553,0.448-1,1-1H21z" />
              <path fill="#107c41" d="M14,6v34H8c-0.552,0-1-0.447-1-1V7c0-0.553,0.448-1,1-1H14z" />
              <path fill="#185c37" d="M7,6v34H4c-0.552,0-1-0.447-1-1V7c0-0.553,0.448-1,1-1H7z" />
              <path fill="#ffffff" d="M19.416,25.147l-4.032-6.259l3.937-6.107h-3.491l-2.032,3.768 c-0.146,0.277-0.242,0.475-0.287,0.593h-0.04c-0.091-0.224-0.187-0.427-0.287-0.608l-2.13-3.753h-3.633l3.927,6.12l-4.122,6.246h3.43 l2.289-4.067c0.091-0.155,0.179-0.352,0.264-0.59h0.044c0.063,0.169,0.159,0.371,0.287,0.605l2.354,4.052H19.416z" />
            </svg>
          );
        }
    
        return (
          <span className="file_icons position-absolute">
            <svg width={22} height={24} viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M13.325 0C14.675 0 16.025 0.6 16.85 1.725L20.525 6.3C21.125 7.125 21.5 8.1 21.5 9.075V19.5C21.5 21.975 19.475 24 17 24H5C2.525 24 0.5 21.975 0.5 19.5V4.5C0.5 2.025 2.525 0 5 0H13.325ZM15.65 8.475C14.3 7.125 12.2 6.975 10.7 8.175C10.4 8.4 10.325 8.925 10.55 9.225C10.775 9.525 11.3 9.6 11.6 9.375C12.5 8.7 13.775 8.775 14.525 9.6C15.425 10.5 15.425 11.925 14.525 12.75L11.9 15.375L10.625 16.65L10.55 16.725C9.65 17.55 8.3 17.475 7.475 16.65C6.65 15.825 6.575 14.475 7.4 13.575L7.475 13.5L9.2 11.775L9.275 11.7C9.575 11.475 10.025 11.475 10.25 11.775C10.55 12.075 10.55 12.525 10.25 12.825L8.525 14.55L8.45 14.625C8.225 14.925 8.225 15.375 8.525 15.6C8.825 15.9 9.275 15.9 9.575 15.6L11.3 13.875L11.375 13.8C12.125 12.9 12.125 11.55 11.3 10.725C10.4 9.825 8.975 9.825 8.15 10.725L7.475 11.4L7.4 11.475L6.95 11.925L6.425 12.45C4.925 13.95 4.925 16.275 6.425 17.775C7.925 19.275 10.25 19.275 11.75 17.775L13.475 16.05L13.55 15.975L15.725 13.8L15.875 13.65C17.075 12.225 17.075 9.9 15.65 8.475Z" fill="#131313" fillOpacity="0.4" />
            </svg>
          </span>
        );
      };

    const displayError = (fieldName) =>
        contactUsForm.touched[fieldName] && contactUsForm.errors[fieldName];

    return <>
        <JqueryLoad />
        <Hdashboard />
        <header className="dashboard-toolbar d-lg-flex justify-content-between">
            <div className="align-items-center justify-content-between d-flex">
                <div className="d-flex align-items-center">
                    <a className="menu-toggle align-items-center d-lg-none d-flex">
                        <i className="fa fa-bars" />
                    </a>
                    <a href="index.php" className="d-lg-none d-block brand-logo">
                        <img src="./assets/images/logo.png" alt="logo" />
                    </a>
                </div>

            </div>
        </header>

        <section className="main_sec mt-3 mb-5">
            <div className="mx-5 mt-4">
                <span onClick={handleBack}>
                    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" ></path>
                    </svg>

                    <span className="ms-2">Back</span>
                </span>
            </div>
            <div className="title">
                <p className="fs-4 fw-500 text-center mb-5 poppins">Send Email</p>
            </div>

            <div className="row g-4 align-items-center justify-content-center">
                <div className="col-lg-8">
                    <div className="card border-purple p-4">
                        <form className="custom_form mt-4" name="contactUsForm" onSubmit={contactUsForm.handleSubmit}>

                            <div className="form-group mb-4">
                                <label htmlFor="subject" className="mb-2">Subject</label>
                                <input type="text" className="form-control" name="subject" value={contactUsForm.values.subject} onChange={contactUsForm.handleChange} />
                                {displayError("subject") && (
                                    <div className="text-danger">{contactUsForm.errors.subject}</div>
                                )}
                            </div>

                            <div className="form-group mb-4">
                                <label className="mb-2" htmlFor="body">Body</label>
                                <textarea type="text" className="form-control" name="body" value={contactUsForm.values.body} onChange={contactUsForm.handleChange} rows={8}></textarea>
                                {displayError("body") && (
                                    <div className="text-danger">{contactUsForm.errors.body}</div>
                                )}
                            </div>

                            <div className="form-group mb-4">
                                <label className="mb-2">Upload Attachments</label>
                                <div className="row">
                                    {[0, 1, 2].map((index) => (
                                        <div className="col-lg-4" key={index}>
                                            <div className="form-group mb-lg-0 mb-4 file_upload">
                                                <div
                                                    className="file_update position-relative d-flex align-items-center justify-content-center"
                                                    style={{ height: '166px', border: '1px solid #ddd', borderRadius: '8px', cursor: 'pointer' }}
                                                    onClick={() => fileInputs.current[index]?.click()}
                                                >
                                                    {renderFilePreview(index)}
                                                </div>
                                                <input  
                                                    type="file"
                                                    className="form-control"
                                                    name="attachment"
                                                    accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx"
                                                    ref={(el) => (fileInputs.current[index] = el)}
                                                    onChange={(e) => handleImage(e, index)}
                                                    style={{ display: 'none' }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="button mt-5 mb-2 d-flex justify-content-center">
                                <button type="submit" className="btn-theme px-4 py-2  text-center text-dif-black fw-500 bg-yellow mb-xl-0 mb-3 d-inline-block">Send</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    </>
}
